import { ProgramHeaderItem } from "../types";
import ProgramHeaderBehaviour from "./programHeaderBehaviour";
import TradeProgramStatus from "shared/enums/TradeProgramStatus";
import BuyersProgramStatus from "shared/enums/BuyersProgramStatus";
import MeetupProgramStatus from "shared/enums/MeetupProgramStatus";
import TabletalkProgramStatus from "shared/enums/TabletalkProgramStatus";
import AssociatedProgramStatus from "shared/enums/AssociateProgramStatus";
import InPersonMeetupProgramStatus from "shared/enums/InPersonMeetupProgramStatus";

export class EmptyBehaviour extends ProgramHeaderBehaviour {
  getInPersonMeetupProgramStatusHeaderList(): Array<ProgramHeaderItem<InPersonMeetupProgramStatus>> {
    return [];
  }

  getBuyersProgramStatusHeaderList(): Array<ProgramHeaderItem<BuyersProgramStatus>> {
    return [];
  }

  getMeetupProgramStatusHeaderList(): Array<ProgramHeaderItem<MeetupProgramStatus>> {
    return [];
  }

  getTradeProgramStatusHeaderList(): Array<ProgramHeaderItem<TradeProgramStatus>> {
    return [];
  }

  getTabletalkProgramStatusHeaderList(): Array<ProgramHeaderItem<TabletalkProgramStatus>> {
    return [];
  }

  getAssociatedProgramStatusHeaderList(
    _: AssociatedProgramStatus,
    _1?: string
  ): Array<ProgramHeaderItem<AssociatedProgramStatus>> {
    return [];
  }
}
